import React from 'react';
import { Box, Stack, styled, Typography } from '@mui/material';
import { IStrengthMeter } from './interfaces';
import { StrengthBlock } from './components/StrengthBlock';
import { useTranslation } from 'react-i18next';

export const StrengthMeter: React.FC<IStrengthMeter> = ({
  strength,
}): JSX.Element => {
  const { t } = useTranslation();

  const activeColor = (() => {
    if (strength > 50) {
      return '#028356';
    }

    if (strength > 25) {
      return '#F2A622';
    }

    return '#CF2C29';
  })();

  const hintText = (() => {
    let key = 'noValue';

    if (strength > 75) {
      key = 'strong';
    } else if (strength > 50) {
      key = 'good';
    } else if (strength > 25) {
      key = 'weak';
    } else if (strength > 1) {
      key = 'veryWeak';
    }

    return t(`forms:fields.passwordField.strength.${key}`);
  })();

  return (
    <Box
      sx={{
        padding: '5px 0 0',
      }}
    >
      <Stack direction="row" gap="5px">
        <StrengthBlock active={strength > 0} activeColor={activeColor} />
        <StrengthBlock active={strength > 25} activeColor={activeColor} />
        <StrengthBlock active={strength > 50} activeColor={activeColor} />
        <StrengthBlock active={strength > 75} activeColor={activeColor} />
      </Stack>

      <Stack alignItems="end">
        <Typography variant="body2" color="gray">
          {hintText}
        </Typography>
      </Stack>
    </Box>
  );
};
